module.exports = __webpack_public_path__ + "img/photo1.5b8cde0e.jpg";